import { memo, useCallback, useMemo, useState } from 'react';
import { Grid } from '@mui/material';
import Table from 'shell/components/shared/table-person';
import { headCellsFamilyFunc } from './constants';
import { FamilyVM } from 'shell/view-models/family';
import { createSearchParams, useLocation, useNavigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import { useUserProfile } from 'shell/hooks/use-user-profile';

interface TableFamilyProps {
  data?: Array<FamilyVM>;
}

const TableFamilyComponent = ({ data = [] }: TableFamilyProps): React.ReactElement => {
  const [family, onChangeItems] = useState(data);

  const navigate = useNavigate();

  const { userProfile } = useUserProfile();

  const [queryParams] = useSearchParams();

  const nationalSearch = JSON.parse(queryParams.get('ricercaNazionale') || 'false');
  const redirectUri = queryParams.get('redirectUri') || '';
  const idFamigliaANPR = queryParams.get('idFamigliaANPR') || '';

  const location = useLocation();
  const { pathname: actualPathname } = location;

  const onClickItem = useCallback(
    (item: FamilyVM) => {
      navigate({
        pathname: actualPathname,
        search: `?${createSearchParams({
          ricercaNazionale: nationalSearch || 'false',
          codiceFiscale: item?.fiscalCode || '',
          idSchedaSoggettoANPR: item.generality?.anprIdentifier || '',
          redirectUri,
          idFamigliaANPR,
        })}`,
      });
    },
    [family, onChangeItems]
  );

  const body = useMemo(() => {
    return family.map((item) => {
      return {
        ...item,
      };
    });
  }, [family, onClickItem]);

  const headCellsFamily = useMemo(() => {
    return headCellsFamilyFunc(userProfile);
  }, [userProfile]);

  return body.length > 0 ? (
    <Grid container item spacing={2}>
      <Grid item xs={12}>
        <Table head={headCellsFamily} body={body} ariaLabel="Lista Famiglia" minWidth={1300} />
      </Grid>
    </Grid>
  ) : (
    <></>
  );
};

TableFamilyComponent.displayName = 'Family step component';

const TableFamily = memo(TableFamilyComponent);

export default TableFamily;
